import Vue from 'vue'
import Router from 'vue-router'
import Report from '@/components/Report'
import Case from '@/components/Case'
import Register from '@/components/Register'
import Login from '@/components/Login'
import Order from '@/components/Order'
import OrderSanye from '@/components/OrderSanye'
import OrderSuccess from '@/components/OrderSuccess'
import OrderFail from '@/components/OrderFail'
import MyOrder from '@/components/MyOrder'
import ForgotAccount from '@/components/ForgotAccount'
import Topic from '@/components/Topic'
import Record from '@/components/Record'
import TopicInfo from '@/components/TopicInfo'
import My from '@/components/My'
import ChooseHos from '@/components/ChooseHos'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'ChooseHos',
      component: ChooseHos
    },
    {
      path: '/order',
      name: 'Order',
      component: Order
    },
    {
      path: '/orderSanye',
      name: 'OrderSanye',
      component: OrderSanye
    },
    {
      path: '/orderSuccess',
      name: 'OrderSuccess',
      component: OrderSuccess
    },
    {
      path: '/orderFail',
      name: 'OrderFail',
      component: OrderFail
    },
    {
      path: '/report',
      name: 'Report',
      component: Report
    },
   {
      path: '/case',
      name: 'Case',
      component: Case
    },
    {
      path: '/register/:regType',
      name: 'Register',
      component: Register
    },
    {
      path: '/login/:type',
      name: 'Login',
      component: Login
    },
    {
      path: '/myOrder',
      name: 'MyOrder',
      component: MyOrder
    },
    {
      path: '/forgotAccount/:forgotType',
      name: 'ForgotAccount',
      component: ForgotAccount
    },
    {
      path: '/topic',
      name: 'Topic',
      component: Topic
    },
    {
      path: '/record',
      name: 'Record',
      component: Record
    },
    {
      path: '/topicInfo/:topicId',
      name: 'TopicInfo',
      component: TopicInfo
    },
    {
      path: '/my',
      name: 'My',
      component: My
    }
  ]
})

router.beforeEach((to, from, next) => {
    const { path } = to;

    _hmt.push(['_trackPageview', path]);

    next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js